import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import "../userDashboard.css";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import { IAuthType } from "../../../apiservice/authService.type";
import { useAppSelector } from "../../../Redux/reduxCustomHook";
import { RootState } from "../../../Redux/store";
import { NotificationList } from "../../../components/sharedcomponents/notificationList";

export const NotificationsPage = () => {
  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  return (
    <>
      <div className="container" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Notification"
        ></TopBar>
        <div className="text-center mt-8 text-gray-600 dark:text-stone-400">No Notification At the moment.</div>
        {/* <NotificationList></NotificationList> */}
        <Tabbar></Tabbar>
      </div>
    </>
  );
};

export default NotificationsPage;
